export default __webpack_public_path__ + "locales/sq-AL/EmptyTrashDialog.json?hash=8283a1afa6e6d9a8e02704eadc666dde";